import { initSentryClient } from './lib/hooks/sentry.hooks.client';

const { handleError } = initSentryClient();

export { handleError };

export const init = () => {};
